import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/** Wraps authenticated app shell; loads session and redirects to `/login` when required. */
export function RequireAuth() {
  const { loading, authRequired, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="workspace workspace--empty" style={{ padding: "3rem 1.5rem", textAlign: "center" }}>
        <p className="section-lead">Checking sign-in…</p>
      </div>
    );
  }

  if (authRequired && !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
